import React, { useCallback, useEffect, useRef, useState } from "react"
import { Card } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"
import { CardBody } from "../../../../../../_metronic/_partials/controls/index.js"
import {
  formatterRowComponent,
  initialFilterTable
} from "../../../../../../component/atoms/Tabel/index.jsx"
import { EmptyCard, Search, TableSkeleton, TableView } from "../../../../../../component/index.jsx"
import { getUrlParsingPageFilter } from "../../../../../../config/EndpointCollection.js"
import { ILLUSTRATION_CONSTANTS } from "../../../../../../constants/ImageConstants.js"
import { getMasterBaseOpsTeamList } from "../../../../../../redux/actions/MasterDataAction.jsx"
import { stringFormatting } from "../../../../../helpers/TextHelper.js"
import { useUrlParam } from "../../../../../hooks/useUrlParams.jsx"
import { DetailSvgIcon } from "../../../../../../component/atoms/Icons/SVG/index.jsx"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"
import { FIELD_OFFICER_ROLE_ENUM } from "../../../../../../constants/StringConstant.js"
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers/AssetsHelpers.js"

export const MasterBaseTabOpsTeam = ({ id }) => {
  const dispatch = useDispatch()
  const { General, MasterData } = useSelector((state) => state)
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const [isActiveSearch, setIsActiveSearch] = useState(false)
  const [search, setSearch] = useState({ keyword: "" })
  const formRef = useRef()
  const [queryStringObj, setQueryStringObj] = useState(undefined)
  const urlParams = useUrlParam()
  const [currentParam] = useState({
    ...initialFilterTable
  })

  useEffect(() => {
    if (queryStringObj?.keyword) {
      setSearch({ keyword: queryStringObj?.keyword })
      setIsActiveSearch(true)
    }
  }, [queryStringObj])

  useEffect(() => {
    setQueryStringObj(urlParams.getUrlParamsObj)
  }, [urlParams.getUrlParamsObj])

  function onSearch(value) {
    setSearch({ keyword: value.keyword })
    setIsActiveSearch(true)
    let param = {
      ...currentParam,
      keyword: value.keyword
    }
    const url = getUrlParsingPageFilter(param)
    history.push({ pathname: location.pathname, search: url })
  }

  function resetSearch() {
    let param = {
      ...currentParam,
      keyword: ""
    }
    const urlParam = getUrlParsingPageFilter(param)
    setSearch({ keyword: "" })
    setIsActiveSearch(false)
    history.push({ pathname: location.pathname, search: urlParam })
  }

  const changePage = useCallback(
    (param) => {
      const currentUrlParams = urlParams.getUrlParamsObj || {}
      const preservedPageSize = param.pageSize || currentUrlParams.size

      let urlParam
      if (param.sortField != null) {
        urlParam = getUrlParsingPageFilter({
          ...currentParam,
          ...param,
          size: preservedPageSize,
          sort: param?.sortField ? param.sortField + "," + param.sortOrder : "",
          keyword: search.keyword
        })
      } else {
        urlParam = getUrlParsingPageFilter({
          ...currentParam,
          ...param,
          size: preservedPageSize,
          keyword: search.keyword
        })
      }
      history.push({ pathname: location.pathname, search: urlParam })
    },
    [search, currentParam, urlParams.getUrlParamsObj]
  )

  const fetchQueryParamData = (param) => {
    return dispatch(getMasterBaseOpsTeamList(id, param))
  }

  useEffect(() => {
    if (id) {
      const result = location?.search
      if (!result || result === '') {
        const defaultParams = getUrlParsingPageFilter(currentParam)
        history.replace({ pathname: location.pathname, search: defaultParams })
      } else {
        fetchQueryParamData(result)
      }
    }
  }, [location.search, id])

  const columnProperties = [
    {
      text: t("table_header_id_fo"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-weight-bolder font-size-lg"}>
              {stringFormatting(e.code)}
            </div>
          </>
        )
      }
    },
    {
      text: t("table_header_name"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div className={"d-flex flex-column"}>
            <span className={"font-size-lg font-weight-bolder"}>{stringFormatting(e.name)}</span>
            <span className={"font-size-base"}>{stringFormatting(e.phone_number)}</span>
          </div>
        )
      }
    },
    {
      text: t("table_header_role"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <>
            <div className={"font-size-lg"}>
              {stringFormatting(e.role_string)}
            </div>
          </>
        )
      }
    },
    {
      text: t("table_header_action"),
      formatter: formatterRowComponent,
      formatExtraData: {
        externalStyle: (e) => (
          <div className={'d-flex align-items-center'}>
            <Link
              to={
                (e?.role_enum === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER ||
                  e?.role_enum === FIELD_OFFICER_ROLE_ENUM.FIELD_MANAGER ||
                  e?.role_enum === FIELD_OFFICER_ROLE_ENUM.FIELD_SUPERVISOR ||
                  e?.role_enum === FIELD_OFFICER_ROLE_ENUM.HARVEST_SPV ||
                  e?.role_enum === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_HARVEST) ? RoutesConstants.FIELD_OFFICER.DETAIL_FO(e?.role_enum, e?.id) :
                  (e?.role_enum === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_AGRONOMIST ||
                    e?.role_enum === FIELD_OFFICER_ROLE_ENUM.DRONE_PILOT_SPV
                  ) ? RoutesConstants.FIELD_OFFICER.DETAIL_FO_AGRONOMIS(e?.role_enum, e?.id) :
                    e?.role_enum === FIELD_OFFICER_ROLE_ENUM.FIELD_OFFICER_QA ? RoutesConstants.FIELD_OFFICER.DETAIL_FO_QA(e?.role_enum, "list-fo", e?.id) : "#"
              }>
              <div className="btn btn-icon btn-detail btn-hover-secondary btn-md">
                <DetailSvgIcon size="2x" />
              </div>
            </Link>
          </div>
        )
      }
    }
  ]

  const currentUrlParams = urlParams.getUrlParamsObj || {}
  const currentPageSize = currentUrlParams.size ? parseInt(currentUrlParams.size) : (MasterData?.page?.currentElement ?? 10)

  return (
    <>
      <div className={"filter-container"}>
        <div className={"position-relative d-flex flex-wrap justify-content-between align-items-center mb-10"}>
          <Search
            isActiveSearch={isActiveSearch}
            placeholder={t("placeholder_search_ops_team")}
            onSubmitForm={onSearch}
            initialValues={search}
            innerRef={formRef}
            name={"keyword"}
            trigerReset={resetSearch}
          />
        </div>
      </div>
      <Card>
        <CardBody>
          <h2 className="font-weight-bolder mb-8">{t("sub_header_ops_team")}</h2>
          {General?.loading ? (
            <TableSkeleton column={4} row={10} />
          ) : (MasterData?.pageData ?? []).length === 0 ? (
            <EmptyCard
              subtitle={
                isActiveSearch ? t("messages_response_empty_search_subtitle") : ""
              }
              image={
                isActiveSearch
                  ? toAbsoluteUrl(ILLUSTRATION_CONSTANTS.EMPTY_STATE_NO_DATA)
                  : toAbsoluteUrl(ILLUSTRATION_CONSTANTS.EMPTY_STATE_DESKTOP)
              }
              body={
                isActiveSearch
                  ? t("messages_response_searching_not_found")
                  : t("messages_response_no_custom", { custom: t("menu_ops_team") })
              }
            />
          ) : (
            ""
          )}
          <TableView
            dataTable={MasterData?.pageData ?? []}
            currentPage={MasterData?.page?.currentPage ?? 0}
            currentElement={currentPageSize}
            totalCount={MasterData?.page?.totalCount ?? 0}
            columnProperties={columnProperties}
            callbackAfterPageChange={changePage}
            loadingGetData={General?.loading}
            initialFilterTable={currentParam}
            ignoreSinglePage
            rowClasses={() => {
              return "cursor-pointer"
            }}
          />
        </CardBody>
      </Card>
    </>
  )
}